// Public retrieval (path 2) rides on top of the lineage page: the QR printed on
// that page is the only way an anonymous holder reaches the file, so the nested
// toggle exists only while the lineage toggle is both visible and ticked.
//
// The third condition is the sponsor's custom-bucket exclusion (note #6, §8.7):
// those documents live in the client's own bucket and are never copied into
// Cybersign's public prefix. The flag is resolved server-side; until it is
// known, this stays permissive and the server remains authoritative — it
// answers public_retrieval: false with reason CUSTOM_BUCKET_EXCLUDED, which the
// post-sign dialog explains.

export type PublicRetrievalToggleVisibilityInput = {
	// Whether the lineage toggle itself is on screen (same hide rules).
	isLineageToggleVisible: boolean;
	// Whether the user has ticked it.
	isLineagePageEnabled: boolean;
	// null means the backend has not told us yet.
	publicRetrievalAllowed: boolean | null;
};

export function shouldShowPublicRetrievalToggle({
	isLineageToggleVisible,
	isLineagePageEnabled,
	publicRetrievalAllowed,
}: PublicRetrievalToggleVisibilityInput): boolean {
	if (!isLineageToggleVisible || !isLineagePageEnabled) {
		return false;
	}

	return publicRetrievalAllowed !== false;
}

// What actually goes on the sign request. Hidden means forced off, and a flag
// that turned out to be false after the upload (the upload-url response is the
// late, authoritative word) drops the request back to false rather than letting
// the server reject it.
export function resolvePublicRetrievalRequest({
	isPublicRetrievalToggleVisible,
	isPublicRetrievalEnabled,
	uploadPublicRetrievalAllowed,
}: {
	isPublicRetrievalToggleVisible: boolean;
	isPublicRetrievalEnabled: boolean;
	uploadPublicRetrievalAllowed: boolean | null;
}): boolean {
	if (!isPublicRetrievalToggleVisible || !isPublicRetrievalEnabled) {
		return false;
	}

	return uploadPublicRetrievalAllowed !== false;
}
